"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CHILDREN_AGE_ERROR_MESSAGE: ()=>CHILDREN_AGE_ERROR_MESSAGE,
    DEFAULT_MAX_ROOMS: ()=>DEFAULT_MAX_ROOMS,
    DEFAULT_MAX_TRAVELERS: ()=>DEFAULT_MAX_TRAVELERS,
    INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE: ()=>INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE,
    ROOM_SIZE: ()=>ROOM_SIZE,
    WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE: ()=>WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE
});
const ROOM_SIZE = 4;
const DEFAULT_MAX_TRAVELERS = 8;
const DEFAULT_MAX_ROOMS = 4;
const CHILDREN_AGE_ERROR_MESSAGE = "Please enter children's ages to get the best price for your group";
const INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, Priceline does not offer lap infant seating on international flights';
const WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = 'Sorry, we do not offer lap infant seating on international flights';
exports.CHILDREN_AGE_ERROR_MESSAGE = __webpack_exports__.CHILDREN_AGE_ERROR_MESSAGE;
exports.DEFAULT_MAX_ROOMS = __webpack_exports__.DEFAULT_MAX_ROOMS;
exports.DEFAULT_MAX_TRAVELERS = __webpack_exports__.DEFAULT_MAX_TRAVELERS;
exports.INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = __webpack_exports__.INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE;
exports.ROOM_SIZE = __webpack_exports__.ROOM_SIZE;
exports.WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE = __webpack_exports__.WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CHILDREN_AGE_ERROR_MESSAGE",
    "DEFAULT_MAX_ROOMS",
    "DEFAULT_MAX_TRAVELERS",
    "INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE",
    "ROOM_SIZE",
    "WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
